<template>
  <div class="h-screen overflow-hidden bg-gray-50 flex flex-col">
    <router-view v-slot="{ Component }">
      <template v-if="auth.isLoading">
        <div class="flex-1 min-h-0 flex items-center justify-center bg-gray-50">
          <div class="text-center">
            <div class="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p class="text-gray-600">Yükleniyor...</p>
          </div>
        </div>
      </template>
      <component v-else :is="Component" />
    </router-view>
    <Toaster richColors position="top-right" closeButton />
  </div>
</template>

<script setup lang="ts">
import { Toaster } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
</script>
